import React from 'react';
import PropTypes from 'prop-types';
import withRouter from 'HOCs/withRouter';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage as Translation } from 'react-intl';
import AsyncUsersModal from 'Components/UsersModal/AsyncUsersModal';
import css from './Follows.scss';
import {
    getMeta,
    getFollowers,
    getFollowing,
    loadNextPageFollowers,
    loadNextPageFollowing
} from 'Actions/users';
import {
    metaSelector,
    isFriendsInCommonFetching,
    followersSelector,
    followingSelector,
    isFollowersFetching,
    isFollowingFetching
} from 'Selectors/users';

export class Follows extends React.Component {
    static propTypes = {
        meta: PropTypes.object,
        getMeta: PropTypes.func.isRequired,
        followers: PropTypes.array,
        following: PropTypes.array,
        getFollowers: PropTypes.func.isRequired,
        getFollowing: PropTypes.func.isRequired,
        isFollowersFetching: PropTypes.bool.isRequired,
        isFollowingFetching: PropTypes.bool.isRequired,
        loadNextPageFollowers: PropTypes.func.isRequired,
        loadNextPageFollowing: PropTypes.func.isRequired,
        userId: PropTypes.string.isRequired,
        inLineFollowBtn: PropTypes.bool
    };

    static defaultProps = {
        meta: {},
        followers: [],
        following: [],
        inLineFollowBtn: false
    };

    constructor() {
        super();

        this.state = {
            modalType: undefined
        };
    }

    componentDidMount() {
        this.props.getMeta();
    }

    componentDidUpdate = prevProps => {
        const { userId: prevUserId } = prevProps;
        const { userId, getMeta } = this.props;

        if (prevUserId !== userId) {
            getMeta();
            this.handleClose();
        }
    }

    getCounters = () => {
        const { meta } = this.props;
        const { counters: { followers, following } = { followers: 0, following: 0 }} = meta;

        return { followers, following };
    }

    handleFollowersClick = () => {
        const { followers } = this.getCounters();

        if (followers > 0) {
            this.setState({
                type: 'followers'
            });
            this.props.getFollowers();
        }
    }

    handleFollowingClick = () => {
        const { following } = this.getCounters();

        if (following > 0) {
            this.setState({
                type: 'following'
            });

            this.props.getFollowing();
        }
    }

    handleClose = () => {
        this.setState({
            type: undefined
        });
    }

    getModalData = () => {
        switch (this.state.type) {
            case 'followers':
                return {
                    users: this.props.followers,
                    title: <Translation id="followers" />,
                    isFetching: this.props.isFollowersFetching
                };
            case 'following':
                return {
                    users: this.props.following,
                    title: <Translation id="following" />,
                    isFetching: this.props.isFollowingFetching
                };
            default:
                return undefined;
        }
    }

    loadNextPage = () => {
        switch (this.state.type) {
            case 'followers':
                this.props.loadNextPageFollowers();
                break;
            case 'following':
                this.props.loadNextPageFollowing();
                break;
        }
    }

    render() {
        const { inLineFollowBtn } = this.props;
        const followsClassname = inLineFollowBtn ? css.followBtnInLine : css.followBtnBelow;
        const followItemClassname = inLineFollowBtn ? css.friendsCountInLine : css.friendsCountBelow;
        const { followers, following } = this.getCounters();
        const modalData = this.getModalData();

        return (
            <div className={ followsClassname } data-aut-id="follows" >
                <div
                    className={ followItemClassname }
                    onClick={ this.handleFollowersClick }
                    data-aut-id="followersButton"
                >
                    <span
                        className={ css.number }
                        data-aut-id="followers"
                    >
                        { followers }
                    </span>
                    <span className={ css.text }><Translation id="followers" /></span>
                </div>
                <div
                    className={ followItemClassname }
                    onClick={ this.handleFollowingClick }
                    data-aut-id="followingButton"
                >
                    <span
                        className={ css.number }
                        data-aut-id="following"
                    >
                        { following }
                    </span>
                    <span className={ css.text }><Translation id="following" /></span>
                </div>
                { modalData
                    && <AsyncUsersModal
                        users={ modalData.users }
                        total={ modalData.users.total }
                        cursor={ modalData.users.cursor }
                        title={ modalData.title }
                        isFetching={ modalData.isFetching }
                        handleClose={ this.handleClose }
                        onLoadNextPage={ this.loadNextPage }
                    />
                }
            </div>
        );
    }
}

export const mapStateToProps = (state, ownProps) => {
    const { userId } = ownProps;

    return {
        meta: metaSelector(state, userId),
        followers: followersSelector(state, userId),
        following: followingSelector(state, userId),
        isFriendsInCommonFetching: isFriendsInCommonFetching(state, userId),
        isFollowersFetching: isFollowersFetching(state, userId),
        isFollowingFetching: isFollowingFetching(state, userId)
    };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
    const { userId } = ownProps;

    return {
        getMeta: () => dispatch(getMeta(userId)),
        getFollowers: () => dispatch(getFollowers(userId)),
        getFollowing: () => dispatch(getFollowing(userId)),
        loadNextPageFollowers: () => dispatch(loadNextPageFollowers(userId)),
        loadNextPageFollowing: () => dispatch(loadNextPageFollowing(userId))
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(Follows);
